export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "فتح مركز الأدلة",
    fabLabel: "الأدلة",
    assistantAria: "مساعد الأدلة",
    dontShowAgain: "عدم الإظهار مرة أخرى",
    centerAria: "مركز الأدلة",
    eyebrow: "مركز الأدلة",
    title: "تعلّم WACheckin",
    watchedOf: "{watched} من {total} تمت مشاهدتها",
    close: "إغلاق",
    searchPlaceholder: "ابحث عن دليل…",
    forThisScreen: "لهذه الشاشة",
    watched: "تمت المشاهدة",
    watchGuide: "مشاهدة الدليل",
    comingSoon: "قريبًا: تحسينات وتحديثات جديدة.",
    noResults: "لا توجد نتائج لـ “{query}”.",
    needHelp: "بحاجة إلى مساعدة؟ ",
    contactWhatsApp: "راسلنا عبر WhatsApp",
    lightboxMeta: "{section} · الدليل {n} من {total}",
    videoTitle: "فيديو إرشادي",
    playerAria: "مشغّل الدليل",
    prev: "السابق",
    watchOnYouTube: "المشاهدة على YouTube",
    next: "التالي",
    sections: {
      inicio: "الخطوات الأولى",
      alojamiento: "مكان إقامتك",
      tarifas: "الأسعار والقنوات",
      calendario: "التقويم والحجوزات",
      huesped: "تجربة النزيل",
      autoridades: "السلطات",
      novedades: "الجديد",
    },
    videos: {
      navigate: "الدخول والتنقل بين الإعدادات",
      propertyData: "بيانات مكان إقامتك وموقعه وهويته",
      checkinWelcome: "تسجيل الدخول ورسالة الترحيب والسياسات",
      basePrices: "الأسعار الأساسية والأسعار المشتقة حسب القناة",
      calendar: "التقويم: الحجوزات والإتاحة والأسعار",
      guestJourney: "رحلة النزيل: الرسائل والرموز والأتمتة",
      guestVerification: "التحقق من النزيل وطلب التقييمات",
      authorities: "ربط السلطات وإرسال بلاغات المسافرين",
    },
    ai: {
      cta: "عرض قائمة الفيديوهات",
      assistant: "المساعد",
      inicio: "أول يوم لك هنا؟ سأعلّمك الأساسيات في دقيقتين.",
      alojamiento: "تُعِدّ مكان إقامتك؟ شاهد كيف تجعله مثاليًا.",
      tarifas: "أسئلة حول الأسعار؟ سأشرح لك الأسعار حسب القناة.",
      calendario: "هل تريد إتقان التقويم؟ الحجوزات والأسعار والإتاحة.",
      huesped: "هل نُؤتمت رحلة النزيل؟ سأعلّمك خطوة بخطوة.",
      autoridades: "هل نربط السلطات؟ أرسِل بلاغات المسافرين في فيديو واحد.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "أخبار النظام",
    latestUpdates: "آخر التحديثات",
    close: "إغلاق",
    tabNews: "الجديد",
    reports: "البلاغات",
    loading: "جارٍ التحميل…",
    emptyNews: "لا يوجد جديد بعد. سترى التحسينات هنا فور نشرها.",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    reportProblem: "الإبلاغ عن مشكلة",
    emptyReports: "لم ترسل أي بلاغ بعد.",
    sendReport: "+ إرسال بلاغ",
    sendNewReport: "+ إرسال بلاغ جديد",
    capturesCount: "{count} لقطة | {count} لقطات",
    viewConversation: "عرض المحادثة ←",
    new: "جديد",
    openedOn: "فُتح في {date}",
    conversationWithSupport: "محادثة مع فريق الدعم",
    you: "أنت",
    support: "الدعم",
    noReplyYet: "لم يردّ أحد من الفريق بعد. سنُعلمك هنا فور ردّهم.",
    replyPlaceholder: "اكتب ردّك…",
    send: "إرسال",
    replyHint: "<b>Enter</b> للإرسال · <b>Shift + Enter</b> لسطر جديد",
    back: "رجوع",
    sendReportTitle: "إرسال بلاغ",
    formSubtitle: "أخبرنا بما حدث وسنراجعه. سترى الرد في بلاغاتك.",
    about: "بخصوص",
    whatHappens: "ما المشكلة؟",
    titlePlaceholder: "لخّصها في جملة واحدة",
    describeDetail: "صِفها بالتفصيل",
    descPlaceholder: "ما الذي توقعته، وما الذي حدث، وكيفية إعادة إنتاجه.",
    capture: "لقطة شاشة",
    optional: "اختياري",
    attachHint: "اضغط لإرفاق صورة",
    sending: "جارٍ الإرسال…",
    submitReport: "إرسال البلاغ",
    prev: "السابق",
    next: "التالي",
    today: "اليوم",
    yesterday: "أمس",
    status: {
      open: "مفتوحة",
      in_progress: "قيد المعالجة",
      resolved: "تم الحل",
      closed: "مغلقة",
    },
    errRequired: "أخبرنا بما يحدث.",
    errSend: "تعذّر الإرسال. حاول مرة أخرى.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "التحقق من الهوية",
    subtitle: "لإتمام تسجيل دخولك، نحتاج إلى التحقق من هويتك",
    idDocument: "وثيقة الهوية",
    idDocumentDesc: "التقط صورة واضحة للوجه الأمامي من وثيقتك (بطاقة هوية أو تصريح إقامة أو بطاقة وطنية أو جواز سفر أو رخصة)",
    selfie: "صورة ذاتية",
    selfieDesc: "التقط صورة ذاتية يظهر فيها وجهك بوضوح",
    requirements: "المتطلبات:",
    req1: "إضاءة جيدة",
    req2: "الوثيقة كاملة داخل الإطار",
    req3: "نص مقروء",
    req4: "صورة ذاتية دون إكسسوارات تحجب الوجه",
    start: "بدء التحقق",
    frontTitle: "الوجه الأمامي للوثيقة",
    alignDocument: "حاذِ وثيقتك داخل الإطار",
    hintLegible: "تأكد من أن جميع البيانات مقروءة",
    faceTitle: "التحقق من الوجه",
    alignFace: "حاذِ وجهك داخل الدائرة",
    hintLookCamera: "انظر مباشرة إلى الكاميرا دون إكسسوارات",
    reviewTitle: "راجع صورك",
    reviewSubtitle: "تأكد من أن جميع الصور واضحة ومقروءة",
    frontDocTitle: "الوجه الأمامي للوثيقة",
    retake: "إعادة الالتقاط",
    back: "رجوع",
    submit: "إرسال للتحقق",
    processingTitle: "جارٍ التحقق من هويتك",
    processingDesc: "نتحقق من وثائقك. قد يستغرق هذا بضع ثوانٍ...",
    dontClose: "لا تغلق هذه النافذة",
    successTitle: "تم التحقق بنجاح!",
    successDesc: "تم التحقق من هويتك بنجاح.",
    continue: "متابعة",
    errorTitle: "خطأ في التحقق",
    couldNotVerify: "تعذّر التحقق من هويتك. يرجى المحاولة مرة أخرى.",
    retry: "إعادة المحاولة",
    cameraErrorTitle: "تعذّر الوصول إلى الكاميرا",
    cameraErrorDesc: "تعذّر الوصول إلى الكاميرا. يرجى التحقق من الأذونات والمحاولة مرة أخرى.",
    suggestions: "اقتراحات:",
    tip1: "تأكد من منح أذونات استخدام الكاميرا",
    tip2: "تحقق من عدم استخدام تطبيق آخر للكاميرا",
    tip3: "أعد تشغيل المتصفح إذا استمرت المشكلة",
    tryAgainCamera: "المحاولة مرة أخرى",
    couldNotVerifyShort: "تعذّر التحقق من هويتك",
    serverError: "خطأ في الخادم",
    tryLater: "يرجى المحاولة مرة أخرى لاحقًا",
  },
};
